import { API_BASE_URL, API_REGISTRY } from "../app/config"
import { deleteLodgiqCookie, getFromSession } from "../app/util";

const { UserLogin, UserRequestResetPassword, UserProfile, ReleaseNotes } = API_REGISTRY;

// ─── 2FA Mock ────────────────────────────────────────────────────────────────
// Set to true to simulate a 2fa_required response from the login endpoint.
// Flip to false once the real backend 2FA endpoint is wired up.
const MOCK_2FA_ENABLED = false;

// Stores login credentials during mock flow so verifyOTP can complete
// a real login and get a genuine token + profile.
let _mockLoginPayload = null;

const login = async (payload) => {
    if (MOCK_2FA_ENABLED) {
        _mockLoginPayload = payload;
        await new Promise(r => setTimeout(r, 800));
        const masked = payload.email
            ? payload.email.replace(/^(.{2})(.*)(@.*)$/, (_, a, b, c) => a + b.replace(/./g, '*') + c)
            : 'u***@example.com';
        return {
            status: "2fa_required",
            temp_token: "mock-temp-jwt-" + Date.now(),
            delivery: "email",
            masked_dest: masked,
            expires_in: 90,
        };
    }

    const response = await fetch(API_BASE_URL + UserLogin.uri, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        //mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        //credentials: 'same-origin', // include, *same-origin, omit
        // credentials:'include',
        headers: {
            'Content-Type': 'application/json',

            // "Access-Control-Allow-Origin":API_BASE_URL,
            // "Access-Control-Allow-Credentials": true
            //'Access-Control-Allow-Origin':'*'
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        redirect: 'follow', // manual, *follow, error
        //referrerPolicy: 'origin', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(payload) // body data type must match "Content-Type" header
    });
    console.log(response.headers.get('set-cookie'))
    return response.json();
};


let logoutInProgress = false;

const logout = async (payload) => {
    if (logoutInProgress) {
        console.log("Logout already in progress, skipping...");
        return;
    }
    logoutInProgress = true;

    try {
        const response = await fetch(API_BASE_URL + "users/logout/", {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Token " + payload.token,
            },
            redirect: "follow",
            referrerPolicy: "no-referrer",
        });

        deleteLodgiqCookie("loginCount");
        return await response.json();
    } catch (err) {
        console.error("Logout failed:", err);
    } finally {
        // clear storage only once
        sessionStorage.clear();
        localStorage.clear();

        // release the lock after everything
        logoutInProgress = false;
    }
};


const resetPassword = async (params) => {
    const { payload, uri } = UserRequestResetPassword;
    let method = payload.method ? payload.method : 'POST';
    delete payload.method;
    let requestBody = JSON.stringify(params);
    if (method === 'GET') {
        requestBody = null;
    }
    const response = await fetch(API_BASE_URL + uri, {
        method: method, // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json'
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: requestBody // body data type must match "Content-Type" header
    });
    return response.json();
};
const getUserProfile = async (payload) => {
    const response = await fetch(API_BASE_URL + UserProfile.uri, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json'
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(payload) // body data type must match "Content-Type" header
    });
    return response.json();
};

const getReleaseNotes = async (payload) => {
    const response = await fetch(API_BASE_URL + ReleaseNotes.uri, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json'
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(payload) // body data type must match "Content-Type" header
    });
    return response.json();
};

const verifyOTP = async ({ otp, tempToken, trustDevice, deviceId }) => {
    if (MOCK_2FA_ENABLED) {
        await new Promise(r => setTimeout(r, 600));
        // Use "000000" to simulate a wrong-OTP error during testing
        if (otp === '000000') {
            return { status: "fail", message: "Invalid OTP. Please try again." };
        }
        // Call the real login API with stored credentials so we get a genuine
        // token and profile — making the full login flow work end-to-end.
        if (_mockLoginPayload) {
            const stored = _mockLoginPayload;
            _mockLoginPayload = null;
            const response = await fetch(API_BASE_URL + UserLogin.uri, {
                method: 'POST',
                cache: 'no-cache',
                headers: { 'Content-Type': 'application/json' },
                redirect: 'follow',
                body: JSON.stringify(stored),
            });
            return response.json();
        }
        return { status: "fail", message: "Session expired. Please sign in again." };
    }
    const response = await fetch(API_BASE_URL + "users/2fa/verify/", {
        method: 'POST',
        cache: 'no-cache',
        headers: { 'Content-Type': 'application/json' },
        redirect: 'follow',
        body: JSON.stringify({ otp, temp_token: tempToken, trust_device: trustDevice, device_id: deviceId }),
    });
    return response.json();
};

const resendOTP = async ({ tempToken }) => {
    if (MOCK_2FA_ENABLED) {
        await new Promise(r => setTimeout(r, 500));
        return { status: "success", message: "OTP resent successfully." };
    }
    const response = await fetch(API_BASE_URL + "users/2fa/resend/", {
        method: 'POST',
        cache: 'no-cache',
        headers: { 'Content-Type': 'application/json' },
        redirect: 'follow',
        body: JSON.stringify({ temp_token: tempToken }),
    });
    return response.json();
};

export default {
    login,
    logout,
    resetPassword,
    getUserProfile,
    getReleaseNotes,
    verifyOTP,
    resendOTP,
};